import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Button, Stack } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Reel from '../tools/Reel';
import React, { useState, useEffect } from "react";
import {
    Box,
    Container,
    Grid,
    Card,
    CardContent,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Backdrop,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { motion } from "framer-motion";
import FilePreview from '../tools/FilePreview';
const live_events_service = require('../../helpers/live_events_service');

const MotionCard = motion(Card);

const primary = "#8B1A1A";
const primaryLight = "rgba(139,26,26,0.08)";
const sectionGap = 8;

const levels = {
    diamante: {
        name: "Diamante",
        price: "USD $10,500",
        color: "#C9B037",
        benefits: [
            "Logotipo de la empresa ubicado en la página web",
            "Proyección de su liderazgo: representante como conferencista destacado (30–40 min)*",
            "Edición de Video exclusivo del conferencista para publicación en redes sociales",
            "Reconocimiento de marca con los media partners del congreso",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "Presencia de marca en la pantalla del salón de conferencias y áreas estratégicas",
            "E-mail marketing a base de datos ABG-EBG y FELABAN",
            "Webinar exclusivo (se remitirá el listado de participantes registrados)",
            "Gafetes de staff: 3 staff + 1 conferencista (incluye alimentos)",
            "5 entradas de cortesía",
            "Transmisión de su Spot en el salón de conferencia (30 seg – 1 min)",
            "Stand 3×2 m con diseño renovado y Pantalla LED",
        ],
    },
    platino: {
        name: "Platino",
        price: "USD $8,500",
        color: "#A8A9AD",
        benefits: [
            "Logotipo de la empresa ubicado en la página web",
            "Reconocimiento de marca con los media partners del congreso",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "E-mail marketing a base de datos ABG-EBG y FELABAN",
            "Webinar exclusivo (se remitirá el listado de participantes registrados)",
            "Gafetes de staff: 2 staff (incluye alimentos)",
            "3 entradas de cortesía",
            "Stand 6×2 m",
        ],
    },
    oro: {
        name: "Oro",
        price: "USD $5,500",
        color: "#AD8A56",
        benefits: [
            "Logotipo de la empresa ubicado en la página web",
            "Reconocimiento de marca con los media partners del congreso",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "E-mail marketing a base de datos ABG-EBG y FELABAN",
            "Webinar exclusivo (se remitirá el listado de participantes registrados)",
            "Gafetes de staff: 1 staff (incluye alimentos)",
            "2 entradas de cortesía",
            "Stand 3×2 m",
        ],
    },
};

const benefitsComparison = [
    { benefit: "Logotipo en página web", diamante: true, platino: true, oro: true },
    { benefit: "Conferencista destacado (30–40 min)*", diamante: "Conferencia 30–40 min", platino: false, oro: false },
    { benefit: "Video exclusivo del conferencista en redes sociales", diamante: true, platino: false, oro: false },
    { benefit: "Reconocimiento de marca con media partners", diamante: true, platino: true, oro: true },
    { benefit: "Acceso exclusivo a plataforma de Networking", diamante: true, platino: true, oro: true },
    { benefit: "Presencia de marca en salón de conferencias", diamante: true, platino: false, oro: false },
    { benefit: "Email marketing ABG-EBG y FELABAN", diamante: true, platino: true, oro: true },
    { benefit: "Webinar exclusivo", diamante: true, platino: true, oro: true },
    { benefit: "Gafetes de staff (con alimentos)", diamante: "3 staff + 1 conferencista", platino: "2 staff", oro: "1 staff" },
    { benefit: "Entradas de cortesía", diamante: "5", platino: "3", oro: "2" },
    { benefit: "Spot en salón de conferencias (30 seg – 1 min)", diamante: true, platino: false, oro: false },
    { benefit: "Stand en área de exposición", diamante: "3×2 m + Pantalla LED", platino: "6×2 m", oro: "3×2 m" },
];

const extras = [
    {
        title: "Almuerzo Patrocinado",
        price: "USD $15,200",
        desc: "Almuerzo por día + Patrocinador Nivel Diamante. Presentación especial o reel de videos del patrocinador, músico solista contratado por los organizadores. (1 empresa por día)",
    },
    {
        title: "Coffee Breaks Patrocinados",
        price: "USD $15,200",
        desc: "Coffee breaks + Patrocinador Nivel Diamante. Islas de servicio con la imagen del patrocinador. (1 empresa por día)",
    },
    {
        title: "Cóctel de Bienvenida",
        price: "USD $19,000",
        desc: "Cóctel de Bienvenida + Patrocinador Nivel Diamante. Palabras de inauguración por el patrocinador + branding exclusivo + amenización de un músico en vivo + servicio de boquitas y bebidas. (1 empresa)",
    },
    {
        title: "Cena y Fiesta de Clausura",
        price: "USD $25,000",
        desc: "Cena y fiesta de clausura + Patrocinador Nivel Diamante. Servicio de cena + fiesta con grupo en vivo + branding exclusivo + palabras especiales por el patrocinador + 12 entradas adicionales para invitados estratégicos. (1 empresa)",
    },
    {
        title: "250 Carpetas Oficiales",
        price: "USD $17,500",
        desc: "250 Carpetas + Patrocinador con Beneficios Nivel Diamante. Carpetas con logotipo impreso de la empresa patrocinadora + el logotipo del congreso. (1 empresa)",
    },
    {
        title: "250 Maletines de Viaje",
        price: "USD $17,500",
        desc: "250 Maletines de viaje + Patrocinador con Beneficios Nivel Diamante. Maletines con logotipo impreso de la empresa patrocinadora + el logotipo del congreso. (1 empresa)",
    },
];

const generalBenefits = [
    "Posicionamiento de marca regional en Latinoamérica",
    "Acceso a +250 participantes latinoamericanos del sector financiero",
    "Networking estratégico con expertos en gestión de riesgos y cumplimiento normativo",
    "Exposición en medios digitales e impresos",
    "Participación en conferencias y actividades del congreso",
];

const renderCell = (value) => {
    if (value === true) return <CheckCircleIcon sx={{ color: primary }} />;
    if (value === false) return <CancelIcon sx={{ color: "#ccc" }} />;
    return (
        <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
            {value}
        </Typography>
    );
};

const SectionHeader = ({ children }) => (
    <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" sx={{ color: primary }}>
            {children}
        </Typography>
        <Box
            sx={{
                mt: 1,
                width: 48,
                height: 4,
                borderRadius: 2,
                background: primary,
                opacity: 0.25,
            }}
        />
    </Box>
);

const Patrocinio = () => {
    const [tab, setTab] = useState("diamante");
    const [contador] = useState(0);
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState("");

    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData("/patrocinador/view-by-evento/" + process.env.REACT_APP_EVT)
                    .then(() => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then(() => {
                                setUrl(response_evt.data.response_database.result[0].planos);
                                setLoading(false);
                            })
                            .catch(console.log);
                    })
                    .catch(console.log);
            })
            .catch(console.log);
    }, [contador]);

    return (
        <Stack spacing={0} alignItems="center" sx={{ background: "#f5f7f6" }} pt={3}>

            <Backdrop sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* ── Breadcrumb ── */}
            <Box sx={{ width: "100%", px: { xs: 2, md: 4 } }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" href="/">
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Inicio
                    </Link>
                    <Typography sx={{ color: "text.primary", display: "flex", alignItems: "center" }}>
                        <AttachMoneyIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Patrocinio
                    </Typography>
                </Breadcrumbs>
            </Box>

            {/* ── Reel ── */}
            <Box sx={{ width: "100%" }}>
                <Reel />
            </Box>

            {/* ══════════════════════ MAIN CONTENT ══════════════════════ */}
            <Box sx={{ width: "100%", py: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">

                    {/* ── Hero Header ── */}
                    <Box
                        sx={{
                            mb: sectionGap,
                            pb: sectionGap,
                            borderBottom: `1px solid rgba(139,26,26,0.12)`,
                        }}
                    >
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            sx={{ color: primary, letterSpacing: "-0.5px", mb: 2 }}
                        >
                            PATROCINIOS CLAR 2026
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", mb: 1 }}>
                            XI Congreso Latinoamericano de Riesgos —{" "}
                            <Box component="strong" sx={{ color: "text.primary" }}>
                                Hotel Casa Santo Domingo, Antigua Guatemala
                            </Box>
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 680 }}>
                            Conecta con más de{" "}
                            <Box component="strong" sx={{ color: "text.primary" }}>
                                250 líderes latinoamericanos
                            </Box>{" "}
                            del sector financiero y bancario. Posiciona tu marca y genera oportunidades reales de negocio en el evento más importante de gestión de riesgos financieros en Centroamérica y América Latina.
                        </Typography>
                    </Box>

                    {/* ── Nivel Tabs ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>NIVELES DE PATROCINIO</SectionHeader>

                        <Tabs
                            value={tab}
                            onChange={(_, val) => setTab(val)}
                            sx={{
                                mb: 4,
                                "& .MuiTabs-indicator": { backgroundColor: primary, height: 3, borderRadius: 2 },
                            }}
                            textColor="inherit"
                        >
                            {Object.keys(levels).map((key) => (
                                <Tab
                                    key={key}
                                    value={key}
                                    label={`${levels[key].name}`}
                                    sx={{
                                        fontWeight: "bold",
                                        color: tab === key ? primary : "text.secondary",
                                        textTransform: "none",
                                        fontSize: "0.95rem",
                                        mr: 1,
                                    }}
                                />
                            ))}
                        </Tabs>

                        <MotionCard
                            key={tab}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                            elevation={0}
                            sx={{
                                borderRadius: 4,
                                border: `1.5px solid rgba(139,26,26,0.15)`,
                                overflow: "hidden",
                            }}
                        >
                            <Box sx={{ height: 6, background: levels[tab].color }} />

                            <Box sx={{ p: { xs: 3, md: 5 } }}>
                                <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 4 }}>
                                    Nivel {levels[tab].name}
                                </Typography>

                                <Grid container spacing={1}>
                                    {levels[tab].benefits.map((b, i) => (
                                        <Grid item xs={12} sm={6} key={i}>
                                            <ListItem disableGutters sx={{ py: 0.75, alignItems: "flex-start" }}>
                                                <ListItemIcon sx={{ minWidth: 32, mt: "2px" }}>
                                                    <CheckCircleIcon sx={{ color: primary, fontSize: 20 }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={b}
                                                    primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
                                                />
                                            </ListItem>
                                        </Grid>
                                    ))}
                                </Grid>
                                {tab === "diamante" && (
                                    <Typography variant="caption" sx={{ color: "#999", fontStyle: "italic", mt: 2, display: "block" }}>
                                        *Previa aprobación del Comité académico del congreso y de acuerdo a la temática definida para el mismo.
                                    </Typography>
                                )}
                            </Box>
                        </MotionCard>
                    </Box>

                    {/* ── Tabla Comparativa ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>COMPARATIVO DE BENEFICIOS</SectionHeader>

                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                borderRadius: 4,
                                border: `1.5px solid rgba(139,26,26,0.12)`,
                                overflow: "hidden",
                            }}
                        >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#1a1a2e" }}>
                                        <TableCell
                                            sx={{ color: "#fff", fontWeight: "bold", width: "40%", py: 2, fontSize: "0.85rem" }}
                                        >
                                            Beneficio
                                        </TableCell>
                                        {["Diamante", "Platino", "Oro"].map((lvl) => (
                                            <TableCell
                                                key={lvl}
                                                align="center"
                                                sx={{ color: "#E5E4E2", fontWeight: "bold", py: 2, fontSize: "0.82rem" }}
                                            >
                                                {lvl}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {benefitsComparison.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                "&:nth-of-type(odd)": { backgroundColor: primaryLight },
                                                "&:hover": { backgroundColor: "rgba(139,26,26,0.12)" },
                                                transition: "background 0.2s",
                                            }}
                                        >
                                            <TableCell sx={{ fontSize: "0.82rem", py: 1.5, color: "text.secondary" }}>
                                                {row.benefit}
                                            </TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.diamante)}</TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.platino)}</TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.oro)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* ── File Preview ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <FilePreview url={url} />
                    </Box>

                    {/* ── Beneficios Generales ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>BENEFICIOS GENERALES</SectionHeader>

                        <Grid container spacing={3}>
                            {generalBenefits.map((item, i) => (
                                <Grid item xs={12} sm={6} md={4} key={i}>
                                    <MotionCard
                                        whileHover={{ y: -4 }}
                                        transition={{ duration: 0.2 }}
                                        elevation={0}
                                        sx={{
                                            height: "100%",
                                            p: 3,
                                            borderRadius: 4,
                                            border: `1.5px solid rgba(139,26,26,0.12)`,
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: 2,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                minWidth: 36,
                                                height: 36,
                                                borderRadius: "50%",
                                                background: primaryLight,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mt: "2px",
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ color: primary, fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                                            {item}
                                        </Typography>
                                    </MotionCard>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* ── Paquetes Especiales ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2} mb={4}>
                            <SectionHeader>PAQUETES ESPECIALES DE PATROCINIO</SectionHeader>

                            <Box display="flex" gap={1} alignItems="center" mt={0.5}>
                                <Box
                                    component="button"
                                    onClick={() => {
                                        const el = document.getElementById("extras-scroll");
                                        if (el) el.scrollBy({ left: -320, behavior: "smooth" });
                                    }}
                                    sx={{
                                        width: 40, height: 40,
                                        borderRadius: "50%",
                                        border: `1.5px solid rgba(139,26,26,0.25)`,
                                        background: "#fff",
                                        color: primary,
                                        cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: "1.3rem",
                                        lineHeight: 1,
                                        transition: "all 0.2s",
                                        "&:hover": { background: primary, color: "#fff", borderColor: primary },
                                    }}
                                >
                                    ‹
                                </Box>
                                <Box
                                    component="button"
                                    onClick={() => {
                                        const el = document.getElementById("extras-scroll");
                                        if (el) el.scrollBy({ left: 320, behavior: "smooth" });
                                    }}
                                    sx={{
                                        width: 40, height: 40,
                                        borderRadius: "50%",
                                        border: `1.5px solid rgba(139,26,26,0.25)`,
                                        background: "#fff",
                                        color: primary,
                                        cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: "1.3rem",
                                        lineHeight: 1,
                                        transition: "all 0.2s",
                                        "&:hover": { background: primary, color: "#fff", borderColor: primary },
                                    }}
                                >
                                    ›
                                </Box>
                            </Box>
                        </Box>

                        <Box
                            id="extras-scroll"
                            ref={(el) => {
                                if (!el || el._dragBound) return;
                                el._dragBound = true;
                                let isDown = false, startX = 0, scrollLeft = 0;
                                el.addEventListener("mousedown", (e) => {
                                    isDown = true;
                                    el.style.cursor = "grabbing";
                                    startX = e.pageX - el.offsetLeft;
                                    scrollLeft = el.scrollLeft;
                                });
                                const stop = () => { isDown = false; el.style.cursor = "grab"; };
                                el.addEventListener("mouseleave", stop);
                                el.addEventListener("mouseup", stop);
                                el.addEventListener("mousemove", (e) => {
                                    if (!isDown) return;
                                    e.preventDefault();
                                    const x = e.pageX - el.offsetLeft;
                                    el.scrollLeft = scrollLeft - (x - startX) * 1.5;
                                });
                            }}
                            sx={{
                                display: "flex",
                                gap: 3,
                                overflowX: "auto",
                                pb: 1,
                                cursor: "grab",
                                userSelect: "none",
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                                scrollSnapType: "x mandatory",
                            }}
                        >
                            {extras.map((item, i) => (
                                <MotionCard
                                    key={i}
                                    whileHover={{ y: -5 }}
                                    transition={{ duration: 0.2 }}
                                    elevation={0}
                                    sx={{
                                        minWidth: { xs: 260, sm: 300 },
                                        maxWidth: { xs: 260, sm: 300 },
                                        borderRadius: 4,
                                        border: `1.5px solid rgba(139,26,26,0.12)`,
                                        overflow: "hidden",
                                        flexShrink: 0,
                                        scrollSnapAlign: "start",
                                        display: "flex",
                                        flexDirection: "column",
                                        pointerEvents: "auto",
                                    }}
                                >
                                    <Box sx={{ height: 4, background: primary, opacity: 0.35 }} />
                                    <CardContent sx={{ p: 3, flexGrow: 1 }}>
                                        <Box
                                            sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 28, height: 28,
                                                borderRadius: "50%",
                                                background: primaryLight,
                                                mb: 1,
                                            }}
                                        >
                                            <Typography variant="caption" fontWeight="bold" sx={{ color: primary }}>
                                                {i + 1}
                                            </Typography>
                                        </Box>
                                        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: primary, mb: 0.5, lineHeight: 1.3 }}>
                                            {item.title}
                                        </Typography>                            
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                            {item.desc}
                                        </Typography>
                                    </CardContent>
                                </MotionCard>
                            ))}
                        </Box>
                    </Box>

                    {/* ── CTA ── */}
                    <Box
                        sx={{
                            textAlign: "center",
                            py: { xs: 6, md: 8 },
                            px: { xs: 3, md: 8 },
                            borderRadius: 4,
                            background: `linear-gradient(135deg, rgba(139,26,26,0.07) 0%, rgba(139,26,26,0.03) 100%)`,
                            border: `1.5px solid rgba(139,26,26,0.12)`,
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 1.5 }}>
                            ¿Listo para posicionar tu marca en CLAR 2026?
                        </Typography>
                        <Typography color="text.secondary" sx={{ mb: 4, maxWidth: 560, mx: "auto" }}>
                            Conviértete en patrocinador y conecta con los líderes del sector financiero y bancario de Latinoamérica.
                        </Typography>
                        <Button
                            href="mailto:ncuches@ebg.edu.gt?subject=Interés%20en%20Patrocinio%20CLAR%202026&body=Hola%20equipo%20EBG,%0A%0AEstoy%20interesado(a)%20en%20convertirme%20en%20patrocinador%20del%20CLAR%202026.%20Me%20gustaría%20recibir%20más%20información%20sobre%20los%20niveles%20de%20patrocinio,%20beneficios%20y%20disponibilidad.%0A%0AEmpresa:%20%0ANombre:%20%0ACargo:%20%0ATeléfono:%20%0APaís:%20%0A%0AQuedo%20atento(a)%20a%20su%20respuesta.%0A%0ASaludos."
                            variant="contained"
                            sx={{
                                px: 6,
                                py: 1.75,
                                background: primary,
                                color: "#fff",
                                borderRadius: 3,
                                fontWeight: "bold",
                                fontSize: "1rem",
                                textTransform: "none",
                                boxShadow: `0 8px 24px rgba(139,26,26,0.3)`,
                                transition: "transform 0.25s, box-shadow 0.25s",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: `0 12px 32px rgba(139,26,26,0.4)`,
                                    background: primary,
                                },
                            }}
                        >
                            Quiero ser patrocinador
                        </Button>
                    </Box>

                </Container>
            </Box>
        </Stack>
    );
};

export default Patrocinio;
